import FancyBoxSvg361x765 from './FancyBoxSvg361x765';

export default FancyBoxSvg361x765;
export { FancyBoxSvg361x765 };
